import { truncate } from 'lodash';
import { react2angular } from 'react2angular';

export const NewAlertModalChartTitle = ({ title }: { title: string }): JSX.Element => {
    const truncatedTitle = truncate(title, { length: 100 });
    return title ? <h3 style={{ margin: 0 }}>{truncatedTitle}</h3> : <></>;
};

export const newAlertModalChartTitle = react2angular(NewAlertModalChartTitle, ['title']);
